<template>
  <div>
    <b-modal :id="id" centered size="lg" @show="showModalQuotaEnquesta" @ok="handleSubmitQuotaEnquesta" @hidden="hideModalQuotaEnquesta" :title='$t("admin.enquestes.quota.titol")'>
      <b-form ref="formQuotaEnquesta" @submit.stop.prevent="handleSubmit">

      <b-form-group
        id="input-group-1"
        :label='$t("admin.enquestes.quota.descripcio")+":"' label-size="sm"
        label-for="input-1" label-cols="4" label-cols-lg="2"
      >
        <b-form-input
          id="input-1" 
          v-model="formQuotaEnquesta.descripcio"
          type="text"
          required size="sm"
          :placeholder='$t("admin.enquestes.quota.descplaceholder")'
        ></b-form-input>
      </b-form-group>   

      <template v-for="(item,idx) in variablesEntitat">
        <VariableGenere v-bind:key='idx' v-bind:initialValue="getVariable('genere')" v-on:variable-editada="onVariableEditada" v-on:variable-eliminada="onVariableEliminada" v-if='item==="genere"'/>
        <VariableEdat v-bind:key='idx' v-bind:initialValue="getVariable('edat')" v-on:variable-editada="onVariableEditada" v-on:variable-eliminada="onVariableEliminada" v-if='item==="edat"'/>
        <VariableRegioSanitaria v-bind:key='idx' v-bind:initialValue="getVariable('regio-sanitaria')" v-on:variable-editada="onVariableEditada" v-on:variable-eliminada="onVariableEliminada" v-if='item==="regio-sanitaria"'/>
        <VariableSectorSanitari v-bind:key='idx' v-bind:initialValue="getVariable('sector-sanitari')" v-on:variable-editada="onVariableEditada" v-on:variable-eliminada="onVariableEliminada" v-if='item==="sector-sanitari"'/>
        <VariableHospital v-bind:key='idx' v-bind:initialValue="getVariable('hospital')" v-on:variable-editada="onVariableEditada" v-on:variable-eliminada="onVariableEliminada" v-if='item==="hospital"'/>
        <VariableAbs v-bind:key='idx' v-bind:initialValue="getVariable('abs')"  v-on:variable-editada="onVariableEditada" v-on:variable-eliminada="onVariableEliminada" v-if='item==="abs"'/> 
        <VariableTipusSad v-bind:key='idx' v-bind:initialValue="getVariable('tipus-sad')" v-on:variable-editada="onVariableEditada" v-on:variable-eliminada="onVariableEliminada" v-if='item==="tipus-sad"'/>
        <VariableLot v-bind:key='idx' v-bind:initialValue="getVariable('lot')" v-on:variable-editada="onVariableEditada" v-on:variable-eliminada="onVariableEliminada" v-if='item==="lot"'/>
      </template>


    <b-form-group
      label-cols="4" label-cols-lg="2"
      :label='$t("admin.enquestes.quota.objectiu")+":"' label-size="sm"
    >
    <b-input-group>
      <b-form-group class="group-num-respostes mb-0 mr-2"
        label-cols-sm="0"
        label=""
        label-for="input-9" 
        description="" 
      >      
      <b-input-group size="sm" append="respostes">
        <b-form-input size="sm" id="input-9" type="number" v-model="formQuotaEnquesta.numMinRespostes" ></b-form-input>
      </b-input-group>              
      </b-form-group>      

      <b-form-group class="group-perc-respostes mb-0 mr-2"
        label-cols-sm="0"
        label=""
        label-for="input-10"
        description="" 
      >
      <b-input-group size="sm" :append='formQuotaEnquesta.percMinRespostes+"%"'>      
        <b-form-input size="sm" id="input-10" v-model="formQuotaEnquesta.percMinRespostes" type="range" min="0" max="100" step="1" ></b-form-input>
      </b-input-group>        
      </b-form-group>
      <span class="m-1" id="tooltip-num-respostes"><b-icon variant="primary" icon="question-circle"></b-icon></span>
      <b-tooltip target="tooltip-num-respostes">Objectiu</b-tooltip>

    </b-input-group>

    </b-form-group>


      </b-form>      
    </b-modal>
  </div>
</template>

<script>
import enquestaService from "../../services/EnquestaService";
import VariableGenere from './VariableGenere.vue';
import VariableEdat from './VariableEdat.vue';
import VariableRegioSanitaria from './VariableRegioSanitaria.vue';
import VariableTipusSad from './VariableTipusSad.vue';
import VariableAbs from './VariableAbs.vue';
import VariableHospital from "@/components/admin/VariableHospital";
import VariableSectorSanitari from "@/components/admin/VariableSectorSanitari";
import VariableLot from "@/components/admin/VariableLot";
export default {
  name: "ModalQuotaEnquesta",
  components: {
    VariableSectorSanitari,
    VariableGenere,
    VariableEdat,
    VariableRegioSanitaria,       
    VariableTipusSad,
    VariableAbs,
    VariableHospital,
    VariableLot
  },  
  props: {
    id: {
      type: String,
      required: true
    },
    quota:{
      type: Object,
      required: true
    }
  },  
  data() {
    return {
      formQuotaEnquesta:{},
      variablesEntitat:[]
    };
  },  
  methods: {
    showModalQuotaEnquesta() { 
    
      this.formQuotaEnquesta = this.emptyForm();
      this.formQuotaEnquesta.idEnquesta = this.quota.idEnquesta
      if(this.quota.idQuota){
            this.formQuotaEnquesta.idQuota = this.quota.idQuota;
            this.formQuotaEnquesta.descripcio = this.quota.descripcio;          
            if(this.quota.percMinRespostes == null){
              this.formQuotaEnquesta.percMinRespostes = 0;
            }else{
              this.formQuotaEnquesta.percMinRespostes = this.quota.percMinRespostes;
            }            
            this.formQuotaEnquesta.numMinRespostes = this.quota.numMinRespostes;
            this.formQuotaEnquesta.variables = this.quota.variables;            
      }
    

    },
    getVariable(codi){
      let i;
      if(!this.quota.variables) return null;
      for(i = 0; i < this.quota.variables.length; i++) {
        if(this.quota.variables[i].codi === codi){          
          return this.quota.variables[i];          
        }
      }
      return null;
    },
    handleSubmitQuotaEnquesta(bvModalEvt) {     
      // Prevent modal from closing
      bvModalEvt.preventDefault();

      // Exit when the form isn't valid
      if (!this.checkFormValidity()) {
        return
      }

      enquestaService.saveQuotaEnquesta(this.formQuotaEnquesta).then(response => {        

        this.$emit('quota-editada', response.data);
        this.hideModalQuotaEnquesta();

        })
        .catch(e => {
          console.log(e);
      });
     
    },
    emptyForm(){
        return {
        idEnquesta:null,  
        idQuota:null,
        descripcio:null,
        numMinRespostes:null,
        percMinRespostes:0,
        variables:[]
        }
    },
    hideModalQuotaEnquesta(bvModalEvt) {      
      // Prevent modal from closing
      if(bvModalEvt){bvModalEvt.preventDefault();} 
      
      // Reset our form values
      this.formQuotaEnquesta = this.emptyForm();

      // Hide the modal manually
      this.$nextTick(() => {
        this.$bvModal.hide(this.id)
      })       

    },
    checkFormValidity() {
      if(!(this.formQuotaEnquesta.descripcio && this.formQuotaEnquesta.descripcio.length>0)){
        return false;
      }
      if(!((this.formQuotaEnquesta.numMinRespostes!=null && this.formQuotaEnquesta.numMinRespostes>0)||(this.formQuotaEnquesta.percMinRespostes!=null && this.formQuotaEnquesta.percMinRespostes>0))){
        return false;
      }
      return true
    },
    onVariableEditada(evt){
      //Actualitzar array variables
      let idx = -1; 
      let i = 0;      
      for(i = 0; i < this.formQuotaEnquesta.variables.length; i++) {
        if(this.formQuotaEnquesta.variables[i].codi === evt.codi){          
          idx = i; break;         
        }
      }
      if(idx<0){
          this.formQuotaEnquesta.variables.push(evt);
      }else{
          this.formQuotaEnquesta.variables[idx] = evt;
      }
      
      console.log(this.formQuotaEnquesta.variables);
    },
    onVariableEliminada(codi){
      //Actualitzar array variables
      let idx = -1; 
      let i = 0;      
      for(i = 0; i < this.formQuotaEnquesta.variables.length; i++) {
        if(this.formQuotaEnquesta.variables[i].codi === codi){          
          idx = i; break;         
        }
      }
      if(idx>=0){
          this.formQuotaEnquesta.variables.splice(idx,1);
      }
      
    },
    listVariables() {
      enquestaService.listVariables()
        .then(response => {
          this.variablesEntitat = [];
          let i;
          for (i = 0; i < response.data.length; i++) {
            this.variablesEntitat.push(response.data[i])
          }
        })
        .catch(e => {
          console.log(e);
        });
    }

  },
  mounted() {
      this.listVariables();
  }
};
</script>

<style>
.group-variable-edat{
  width: 160px;
}
.group-num-respostes{
  width: 180px;
}
#input-var-1{
  width: 180px;
}
#input-var-3{
  width: 180px;
}
</style>